import VatInclusionSwitch from './VatInclusionSwitch'
import vatInclusionSwitchContainer from './vatInclusionSwitchContainer'

export default vatInclusionSwitchContainer(VatInclusionSwitch)
